import { bootSearch } from '../../../../config/boot/bootUrl';
export function buildModeTargetUrl(path: string, search?: string): string {
  try {
    const raw = typeof search === 'string'
      ? search
      : bootSearch();
    const cur = new URLSearchParams(raw);
    const forward = new URLSearchParams();
    for (const key of [
      'noclip',
      'speed',
      'godMode',
      'peaceful',
      'debug',
      'class',
      'name',
      'teleporterDebug',
      'freezePopup',
      'testhooks',
      'touchControls',
    ]) {
      const v = cur.get(key);
      if (v !== null) forward.set(key, v);
    }
    const q = forward.toString();
    return q ? `${path}?${q}` : path;
  } catch {
    return path;
  }
}

export function navigateMode(path: string): void {
  try {
    const w = (globalThis as any).window;
    if (!w?.location) return;
    const target = buildModeTargetUrl(path, bootSearch());
    if (typeof w.location.assign === 'function') {
      w.location.assign(target);
    } else {
      w.location.href = target;
    }
  } catch {
    // Best-effort; navigation failure is rare in browser context.
  }
}
